<mat-card>
	<mat-card-header>
		<mat-card-title><h1><img matCardImage src="assets/img/upsLogo.gif" alt="ups"> {{'UPS.pickupService' | translate}}</h1></mat-card-title>
	</mat-card-header>

	<mat-card-content>
		@if(hasPendingUpsPickupRequest){
			<h3 class="red-text">{{ "HasPendingUpsPickupRequestWarning" | translate }}</h3>
		}

		<h3><i class="fal fa-address-card"></i> {{'UPS.addressSelection' | translate}}</h3>
		<mat-select
			[(ngModel)]="selectedAddressName"
			(selectionChange)="onAddressSelection()"
		>
			<mat-option
				*ngFor="let address of shippingAddresses" [value]="address.AddressName"
			>
			{{ address.AddressName2}}, {{address.AddressName3 ? address.AddressName3 + ", " : ""}}{{address.Street}}, {{address.ZipCode}} {{address.City}}, {{getTextForCountryCode(address.Country)}}
			</mat-option>
		</mat-select>
		<form [formGroup]="upsForm">
			<h3><i class="fal fa-user"></i> {{'UPS.contactPerson' | translate}}</h3>
			<div formGroupName="address">
				<div class="contactName">
					<mat-form-field>
						<mat-label>{{ 'UPS.contactName' | translate }}</mat-label>
						<input matInput
							formControlName="ContactName"
							maxlength="{{maxLengthContactName}}"
							type="text" />
						<mat-error>{{ 'UPS.valueRequired' | translate }}</mat-error>
					</mat-form-field>
				</div>
				<div formGroupName="Phone">
					<div class="phoneNumber">
						<mat-form-field>
							<mat-label>{{ 'UPS.phone' | translate }}</mat-label>
							<input matInput formControlName="Number"/>
							<mat-error>{{ 'UPS.invalidPhoneNumber' | translate }}</mat-error>
						</mat-form-field>
					</div>
				</div>
			</div>
			<h3><i class="fal fa-shipping-timed"></i> {{'UPS.pickupDateTime' | translate}}</h3>
			<div class="dateTimeContainer" formGroupName="dateTime">
				<div class="date">
					<mat-form-field>
						<mat-label>{{ 'UPS.pickupDay' | translate }}</mat-label>
						<input matInput
							formControlName="PickupDate"
							[matDatepicker]="datePicker"
							[min]="getTomorrowDate()">
						<mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
						<mat-datepicker #datePicker
							[startAt]="getTomorrowDate()"
							disabled="false"
						>
						</mat-datepicker>
						<mat-hint>{{'UPS.date' | translate}}</mat-hint>
						<mat-error>{{'UPS.validDateRequired' | translate}}</mat-error>
					</mat-form-field>
				</div>
				<div class="time">
					<mat-form-field>
						<mat-label>{{ 'UPS.start' | translate }}</mat-label>
						<mat-select formControlName="ReadyTime" data-cy="ready-time-select">
								<mat-option *ngFor="let time of getTimeRange(800, 1400)" [value]="time">{{ time | timeFormat }}</mat-option>
						</mat-select>
						<mat-hint>{{'UPS.from' | translate}}</mat-hint>
						@if(readyTime.hasError('timeRangeInvalid')){
							<mat-error>{{'UPS.greater2Hours' | translate}}</mat-error>
						}
					</mat-form-field>
				</div>
				<div class="time">
					<mat-form-field>
						<mat-label>{{ 'UPS.end' | translate }}</mat-label>
						<mat-select formControlName="CloseTime" data-cy="close-time-select">
							<mat-option *ngFor="let time of getTimeRange(1300, 1800)" [value]="time">{{ time | timeFormat }}</mat-option>
						</mat-select>
						<mat-hint>{{'UPS.to' | translate}}</mat-hint>
						@if(closeTime.hasError('timeRangeInvalid')){
							<mat-error>{{'UPS.greater2Hours' | translate}}</mat-error>
						}
					</mat-form-field>
				</div>
			  </div>

			  <h3><i class="fal fa-info-circle"></i> {{ 'UPS.specialInstructionHeader' | translate }}</h3>
				<mat-form-field appearance="fill">
					<mat-label>{{ 'UPS.specialInstruction' | translate }}</mat-label>
					<textarea matInput formControlName="specialInstruction"
						maxlength="{{maxLengthSpecialInstructions}}">
					</textarea>
				</mat-form-field>


		</form>
		<div *ngIf="loading" class="loading-indicator"><i class="fal fa-spinner fa-spin"></i></div>
		<div *ngIf="prn" class="success-indicator" data-cy="ups-confirmation-container">
			<i class="fal fa-check-circle"></i><br/><br/>
			{{'UPS.label' | translate}}<br/><br/>
			{{'UPS.PRN' | translate}}: <strong>{{prn}}</strong><br><br>
			<ux-ups-pickup-print [treatment]="treatment" [user]="user"></ux-ups-pickup-print>
		</div>
	</mat-card-content>
	<mat-card-actions align="end">
		<button mat-raised-button color="primary"
		[disabled]="!upsForm.valid || loading || prn"
		(click)="onSubmit()"
		data-cy="pickupRequest-button">{{'UPS.pickupRequest' | translate}}</button>
	</mat-card-actions>
</mat-card>
